<template>
  <div class="slds-tree_container slds-m-around--x-small container">
    <div class="sections">
      <MenuItem v-for="section in sections" :key="section.header" :section="section" :level="1" />
    </div>
    <SettingsPanel />
  </div>

</template>
<script>
import CheckPermission from '../components/utils/CheckPermission'
import MenuItem from './navigation-menu/MenuItem'
import SettingsPanel from './SettingsPanel'
import sections from '../config/sections'

export default {
  mixins: [CheckPermission],
  components: {
    MenuItem,
    SettingsPanel
  },
  created () {
    const sects = sections
      .map(section => {
        section.sections = section.sections
          .filter(item => {
            return (!item.requiredScope || this.checkPermission(item.requiredScope))
          })

        return section
      })

    this.sections = sects
      .filter(section => section.sections.length && (!section.requiredScope || this.checkPermission(section.requiredScope)))
  },
  data () {
    return {
      collapsed: false,
      sections
    }
  }
}
</script>
<style lang="scss" scoped>
ul {
  list-style-type: none;
  margin: 0;
  padding: 0;
  width: 100%;
}

li a {
  display: block;
  color: #000;
  padding: 8px 16px;
  text-decoration: none;
}

/* Change the link color on hover */
li a:hover {
  background-color: #555;
  color: white;
}

.active {
  background-color: #5c88da;
  color: white;
}

.container {
  display: flex;
  flex-direction: column;
}

.sections {
  flex-grow: 1;
}
</style>
